import {
    ableProps,
    ablePropsInit,
    requiredProps,
    requiredPropsInit,
    validatorProps,
    validatorPropsInit,
    events as baseEvents,
} from '../component-base/props';

export const props = () => [
    ...ableProps,
    {
        key: 'isPageParams',
        label: '是否使用page参数',
        type: 'boolean',
    },
    {
        key: 'placeholder',
        label: '占位文字',
        type: 'string',
    },
    {
        key: 'seletedPlaceholder',
        label: '选择后占位文字',
        type: 'string',
    },
    {
        key: 'apiUrl',
        label: '列表接口',
        type: 'string',
        htmlContent: '<a href="https://docs.corp.kuaishou.com/d/home/fcAAt3eFBld24oAK9pOr1BzgU" target="_blank">订单列表接口查询</a>',
    },
    ...requiredProps,
    ...validatorProps,
];

export const init = () => ({
    ...ablePropsInit,
    placeholder: '请选择',
    seletedPlaceholder: '重新选择',
    apiUrl: '',
    ...requiredPropsInit,
    ...validatorPropsInit,
});

export const name = '选择订单';

export const component = 'mobile-general-form-order';

export const events = [
    'user-input',
    'change',
    ...baseEvents,
];

